import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const TableContainer = styled(Common.TableContainer)``;

export const Table = styled(Common.Table)``;

export const TableHeader = styled(Common.TableHeader)``;

export const TableHeaderRow = styled(Common.TableHeaderRow)``;

export const TableHeaderColumn = styled(Common.TableHeaderColumn)``;

export const TableBody = styled(Common.TableBody)``;

export const TableRow = styled(Common.TableRow)``;

export const TableColumn = styled(Common.TableColumn)`
	padding: 1rem 0.5rem !important;
`;

export const Dialog = styled(Common.Dialog)``;

export const DialogTitle = styled(Common.DialogTitle)``;

export const DialogContent = styled(Common.DialogContent)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const NotFound = styled(Common.NotFound)``;

export const InputGroup = styled(Common.InputGroup).attrs((props) => ({
	margin: '0',
}))``;

export const TextField = styled(Common.TextField)`
	height: 2rem;
	margin: 0 !important;
`;

export const Button = styled(Common.Button)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const CircularButton = styled(Common.CircularButton)``;
